module.exports = __webpack_public_path__ + "static/media/wldd.fceb8040.wav";